module.exports = __webpack_public_path__ + "static/media/lol-orange.af761025.svg";